import { render } from "./InfoButton.vue?vue&type=template&id=a6d7a1c4&scoped=true"
const script = {}

import "./InfoButton.vue?vue&type=style&index=0&id=a6d7a1c4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6d7a1c4"]])

export default __exports__